if(typeof __WEBPACK_EXTERNAL_MODULE_54__ === 'undefined') {var e = new Error("Cannot find module \"JSZip\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_54__;


//////////////////
// WEBPACK FOOTER
// external "JSZip"
// module id = 54
// module chunks = 0